module.exports = __webpack_public_path__ + "img/drops-wins_460.0545c615.png";